import Style, { type StyleProps } from "@client/controls/HTML/Style/component";
import { connectCustom } from "@client/lib/misc";
import { type AppState, ScreenType } from "@client/types";
import desktopMaxCSS from "./desktop-max.ctpl";
import desktopMinCSS from "./desktop-min.ctpl";
import mobileMaxCSS from "./mobile-max.ctpl";
import tabletMaxCSS from "./tablet-max.ctpl";
import tabletMinCSS from "./tablet-min.ctpl";

const CSS = {
  [ScreenType.Mobile]: mobileMaxCSS + tabletMaxCSS + desktopMaxCSS,
  [ScreenType.Tablet]: tabletMinCSS + tabletMaxCSS + desktopMaxCSS,
  [ScreenType.Desktop]: tabletMinCSS + desktopMinCSS + desktopMaxCSS
};

// TODO: get rid of it. This is SOOO hacky. Don't pass in rootSelector - menu will break. Popups don't use this
const mapStateToProps = (state: AppState): StyleProps => ({
  css: CSS[state.viewport.screen]
});

export default connectCustom(mapStateToProps)(Style);
